module.exports = __webpack_public_path__ + "static/media/Drop.3763f2b9.mp3";